import script from "./upload-knowledge.vue?vue&type=script&setup=true&lang=js"
export * from "./upload-knowledge.vue?vue&type=script&setup=true&lang=js"

import "./upload-knowledge.vue?vue&type=style&index=0&id=0ac9296c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ac9296c"]])

export default __exports__